export enum LEASE_KIND_ENUM {
  Puro = 'Puro',
  Financiero = 'Financiero'
}

export enum LEASE_KIND_COLOR_ENUM {
  Puro = 'primary',
  Financiero = 'primary'
}

export enum LEASE_STATUS_ENUM {
  'Activo' = 'Activo',
  'Liquidado' = 'Liquidado',
  'Cancelado' = 'Cancelado',
  'Pendiente' = 'Pendiente',
  'Aprobado' = 'Aprobado'
}

export enum LEASE_STATUS_COLOR_ENUM {
  'Activo' = 'success',
  'Liquidado' = 'primary',
  'Cancelado' = 'danger',
  'Pendiente' = 'warning',
  'Aprobado' = 'info'
}
